export enum PageContent {
  PRODUCTS = 'products',
}
